export enum CardVariant {
    default = 'default',
    small = 'small',
}
